import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import OperationsService from "../../../../api/references/OperationsService";
import { ApiState } from "@baseTypes/baseType";

export interface Operation {
    title: string
    color: string
    id: number
    operationType: string
}

interface OperationsState extends ApiState {
    data: Operation[]
}

const initialState: OperationsState = {
    data: [],
    apiError: undefined,
    isApiLoading: false
}

const fetchReferenceOperations = createAsyncThunk(
    'references/operations',
    async (_, thunkAPI) => {
        try {
            const response = await OperationsService.fetch()
            if (response && response.data) {
                return response.data
            } else {
                throw new Error('Invalid response ' + response)
            }
        } catch (e: any) {
            const message = `An error occurred while fetching API ` + (e?.message || e || '')
            return thunkAPI.rejectWithValue({ message })
        }
    }
)

const operationSlice = createSlice({
    name: 'operationsSlice',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(fetchReferenceOperations.rejected, (state, action) => {
            state.isApiLoading = true
            // @ts-ignore
            state.apiError = action.payload?.message
        })
        builder.addCase(fetchReferenceOperations.pending, (state) => {
            state.isApiLoading = true
            state.apiError = undefined
        })
        builder.addCase(fetchReferenceOperations.fulfilled, (state, action) => {
            state.isApiLoading = false
            state.apiError = undefined
            state.data = action.payload
        })
    },
})

export const actions = { ...operationSlice.actions, fetchReferenceOperations }
export default operationSlice.reducer